export const PAYMENT_METHOD_TYPE = {
  wire: 'wire',
  mailCheck: 'mail_check',
};

export const MIN_ACCOUNT_NUMBER_LENGTH = 4;
export const MIN_MAX_ROUTING_NUMBER_LENGTH = 9;
